import React, { useEffect } from 'react';
import { alertRef } from '../../../../App';
import ButtonGroup from '../../../../Components/ButtonGroup/ButtonGroup';
import { Button } from '../../../../Components/StyledComponents';
import './StoreInfo.scss';
import {cloneDeep} from 'lodash-es';

const ModifyStoreInfo = ({patch,info}) => {
    const [ isParking, setIsParking ] = React.useState(false)
    const [ isVallet, setIsVallet ] = React.useState(false);
    const [ convList, setConList ] = React.useState([])

    React.useEffect(() => {
        if( typeof info.OrderInfo !== 'undefined' && Object.keys(info.OrderInfo).length > 0){
            setIsParking(cloneDeep(info.OrderInfo.ConvenienceInfo.isParking))
            setIsVallet(cloneDeep(info.OrderInfo.ConvenienceInfo.isValet))
            setList()
        }
    },[])

    //편의시설 to array
    const setList = () => {
        let list= [];
        
        if( info.OrderInfo.ConvenienceInfo.isWifi ){
            list.push('와이파이');
        }
        if( info.OrderInfo.ConvenienceInfo.isRoom ){
            list.push('룸');
        }
        if( info.OrderInfo.ConvenienceInfo.isDisabled ){
            list.push('장애인 편의시설');
        }
        if( info.OrderInfo.ConvenienceInfo.isPet ){
            list.push('반려동물 동반');
        }
        if( info.OrderInfo.ConvenienceInfo.isBabySeat ){
            list.push('유아용 좌석');
        }
        if( info.OrderInfo.ConvenienceInfo.isGroup ){
            list.push('단체석');
        }
        if( info.OrderInfo.ConvenienceInfo.isSedentary ){
            list.push('좌식');
        }
        
        setConList(list)
    }

    //편의 시설 array handler
    const handleConvList = (val) => {
        let index = convList.indexOf(val)
        
        if( index === -1) setConList( old => [...old, val])
        else setConList( old => old.filter((data) => data !== val))
    }

    //편의정보 수정
    const patchConv = () =>{
        patch({
            isParking : isParking,
            isValet : isVallet,
            isWifi : findBoolean('와이파이'),
            isRoom : findBoolean('룸'),
            isDisabled : findBoolean('장애인 편의시설'),
            isPet : findBoolean('반려동물 동반'),
            isBabySeat : findBoolean('유아용 좌석'),
            isGroup : findBoolean('단체석'),
            isSedentary : findBoolean('좌식'),
        })
    }

    //편의 시설 array check
    const findBoolean = (key) => {
        let index = convList.indexOf(key)
        if(index === -1) return false
        else return true
    }

    return (
        <div className='mod-store-info'>
            <div className='row'>
                <p className='modal-title'>주차</p>
                <button className={`${ isParking ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 32 }} onClick={() => setIsParking(true)}>
                    <div className='row' style={{ justifyContent : 'center' }}>
                        {
                            isParking ?
                            <img src={require('../../../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            :
                            <img src={require('../../../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                        }
                        가능해요
                    </div>
                </button>

                <button className={`${ !isParking ? 'selected-btn' : 'unselected-btn'}`} onClick={() => setIsParking(false)}>
                    <div className='row' style={{ justifyContent : 'center' }}>
                        {
                            isParking ?
                            <img src={require('../../../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            :
                            <img src={require('../../../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                        }
                        불가능해요
                    </div>
                </button>
            </div>

            <div className='row' style={{ marginTop : 24 }}>
                <p className='modal-title'>발렛파킹</p>
                <button className={`${ isVallet ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 32 }} onClick={() => setIsVallet(true)}>
                    <div className='row' style={{ justifyContent : 'center' }}>
                        {
                            isVallet ?
                            <img src={require('../../../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            :
                            <img src={require('../../../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                        }
                        가능해요
                    </div>
                </button>

                <button className={`${ !isVallet ? 'selected-btn' : 'unselected-btn'}`} onClick={() => setIsVallet(false)}>
                    <div className='row' style={{ justifyContent : 'center' }}>
                        {
                            isVallet ?
                            <img src={require('../../../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            :
                            <img src={require('../../../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                        }
                        불가능해요
                    </div>
                </button>
            </div>

            <div style={{ marginTop : 56 }}>
                <p className='modal-title'>편의시설</p>
            
                <ButtonGroup
                    label=""
                    perRows={4}
                    values={convList}
                    style={{ marginTop : 24 }}
                    options={[
                        { label : '모두선택', value : '모두선택'},
                        { label : '장애인 편의시설', value : '장애인 편의시설'},
                        { label : '와이파이', value : '와이파이'},
                        { label : '룸', value : '룸'},
                        { label : '유아용 좌석', value : '유아용 좌석'},
                        { label : '반려동물 동반', value : '반려동물 동반'},
                        { label : '단체석', value : '단체석'},
                        { label : '좌식', value : '좌식'}
                    ]}
                    onClick={(val) => handleConvList(val)}
                />
            </div>
            
            <div className='btn-row'>
                <Button
                    variant="main" 
                    className='save-btn'
                    onClick={() => alertRef.current.showAlert({ title : `편의정보를 저장하시겠어요?`, isConfirm : true, confirmText : '저장하기', isCancel : true, cancelText : '닫기', onConfirm : () => {alertRef.current.hideAlert();patchConv()} })}
                >
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default ModifyStoreInfo;